const SignIn_ko = {
  ID_SIGNIN_TITLE: "로그인",
  ID_SIGNIN_ID_PLACEHOLDER: "아이디 또는 이메일 입력",
  ID_SIGNIN_PWD_PLACEHOLDER: "비밀번호 입력",
  ID_SIGNIN_LOGIN_BTN: "이메일 로그인",
  ID_SIGNIN_ERROR_EMPTY_ID: "아이디 또는 이메일을 입력하세요.",
  ID_SIGNIN_ERROR_EMPTY_PWD: "비밀번호를 입력하세요.",
  ID_SIGNIN_FIND_ID: "아이디 찾기",
  ID_SIGNIN_FIND_PWD: "비밀번호 찾기",
  ID_SIGNIN_SIGNUP_BTN: "이메일 회원가입",
  ID_SIGNIN_LOGIN_FAIL: "아이디 또는 비밀번호가 틀렸습니다.",
  ID_SIGNIN_SUBTITLE: "Connect with Redbrick",
  ID_EASY_SNS_LOGIN: "간편하게 SNS로 로그인",

  //Find ID
  ID_SIGNIN_FINDID_TITLE: "아이디 찾기",
  ID_SIGNIN_FINDID_DESC:
    "찾으시려는 계정에 등록한 이메일 주소를 입력해 주세요. 계정에 실제 이메일 주소를 등록하지 않았다면, 이메일을 받아 보실 수 없습니다.",
  ID_SIGNIN_FINDID_PLACEHOLDER: "ex)redbrick.official@redbrick.space",
  ID_SIGNIN_FINDID_SENDING: "메일을 발송 중입니다.",
  ID_SIGNIN_FINDID_INPUT_ERR: "계정에 등록된 이메일 주소가 아닙니다.",
  ID_SIGNIN_FINDID_EMPTY_ERR: "이메일을 입력해주세요.",
  ID_SIGNIN_FINDID_FORMAT_ERR: "이메일 형식을 바르게 입력해주세요.",
  ID_SIGNIN_FINDID_SUBMIT_BTN: "이메일 보내기",
  ID_SIGNIN_FINDID_SUCCESS_TITLE: "이메일을\n확인해주세요!",
  ID_SIGNIN_FINDID_SUCCESS_SUBTITLE:
    "{email}의 받은 메일함을 확인해주세요. 3분이 지나도 이메일이 오지 않으면, [다시 보내기] 버튼을 눌러 이메일을 다시 보내주세요.",
  ID_SIGNIN_FINDID_SUCCESS_BTN: "다시 보내기",
  ID_SIGNIN_FINDID_LOST_PWD: "비밀번호를 잃어버리셨나요?",
  ID_SIGNIN_FINDID_FIND_PWD: "비밀번호 찾기",

  //Find PWD
  ID_SIGNIN_FINDPWD_TITLE: "비밀번호 찾기",
  ID_SIGNIN_FINDPWD_DESC:
    "임시 비밀번호 발급을 위해 아이디와 이메일을 입력해 주세요. 계정에 실제 이메일 주소를 등록하지 않으셨다면, 이메일을 받아보실 수 없습니다.",
  ID_SIGNIN_FINDPWD_ID_PLACEHOLDER: "아이디를 입력해주세요.",
  ID_SIGNIN_FINDPWD_EMAIL_PLACEHOLDER: "인증하신 이메일 주소를 입력해 주세요.",
  ID_SIGNIN_FINDPWD_ID_EMPTY_ERR: "아이디를 입력해주세요.",
  ID_SIGNIN_FINDPWD_ID_INPUT_ERR: "레드브릭에 등록된 아이디가 아닙니다",
  ID_SIGNIN_FINDPWD_INPUT_ERR: "레드브릭에 등록되지 않은 아이디 또는 이메일입니다. 다시 확인해주세요.",
  ID_SIGNIN_FINDPWD_EMPTY_ERR: "이메일을 입력해주세요.",
  ID_SIGNIN_FINDPWD_FORMAT_ERR: "이메일 형식을 바르게 입력해주세요.",
  ID_SIGNIN_FINDPWD_SUBMIT_BTN: "이메일 보내기",
  ID_SIGNIN_FINPWD_SUCCESS_TITLE: "임시 비밀번호가\n발급되었습니다.",
  ID_SIGNIN_FINDPWD_RESENT_SUCCESS: "메일이 재발송 되었습니다.",

  // Guest Mode
  ID_SIGNIN_GUEST_MDOE_BTN: "GUEST MODE",

  // 휴대폰 등록
  ID_SETTING_SAVE: "저장",
  ID_SETTING_SUCCESS_BTN: "확인",
  ID_SETTING_SENDING: "전송 중...",
  ID_SETTING_PHONE_TITLE: "휴대폰 등록",
  ID_SETTING_PHONE_SUBTITLE: "계정에 등록할 휴대폰 번호를 인증해주세요.",
  ID_SETTING_PHONE_NUM_PLACEHOLDER: "휴대폰 번호를 입력해 주세요.",
  ID_SETTING_PHONE_CODE_PLACEHOLDER: "인증번호를 입력해 주세요.",
  ID_SETTING_PHONE_VERIFY_BUTTON: "번호 인증",
  ID_SETTING_PHONE_SUCCESS: "휴대폰 번호가 인증되었습니다.",
  ID_SETTING_PHONE_WRONG_NUM: "휴대폰 번호를 바르게 입력해 주세요.",
  ID_SETTING_PHONE_DUPLICATE: "이미 등록된 휴대폰 번호입니다. 다른 휴대폰 번호를 입력해 주세요.",
  ID_SETTING_PHONE_CODE_ERR: "인증번호가 올바르지 않습니다.",
  ID_SETTING_PHONE_CODE_ERR_TIMEOUT: "인증번호가 만료되었습니다. 재발송 요청해주세요.",
  ID_SETTING_PHONE_CODE_SUCCESS: "인증이 완료되었습니다.",
  ID_SETTING_VERIFY_COMPLETE: "인증 완료",
  ID_SETTING_VERIFY_WAIT: "인증 대기중",
  ID_SETTING_PHONE_SAVE: "휴대폰 번호가 저장되었습니다.",

  // sns
  ID_KAKAO_INAPP_GOOGLE_LOGIN_ERROR: "Google login is not available with Kakao Talk policy. Please use a different web browser.",
  ID_UNLINK_SNS_GOOGLE: "구글 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_NAVER: "네이버 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_KAKAO: "카카오 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_FACEBOOK: "페이스북 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_MICROSOFT: "마이크로소프트 계정 연동을 해제할까요?",
  ID_UNLINK_SNS_UNABLE: "최초 가입 시 선택한 SNS 계정은  해제할 수 없습니다.",
  ID_ALREADY_LINKED_SNS: "이미 다른 계정에 연동된 SNS 계정입니다.",
  ID_PWD_UNCHANGABLE: `SNS 간편 로그인으로 가입하신 경우\n비밀번호 변경을 할 수 없습니다.`,
  ID_LOGIN_EMAIL_ERROR: `SNS 회원정보의 이메일 주소가\n등록된 계정으로만 로그인 가능합니다.\n계정 정보를 확인하시고 다시 시도해 주세요.`,
};

export default SignIn_ko;
